"use strict";
/*globals document*/
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Nav_1 = require("./Nav");
const ApplicationStore_1 = require("../stores/ApplicationStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const fluxible_router_1 = require("fluxible-router");
const pages = require("../../backend/configs/routes");
const clientDebug_1 = require("../clientDebug");
const react_helmet_1 = require("react-helmet");
class Application extends React.Component {
    constructor(props) {
        super(props);
        this.closeMenu = () => {
            this.setState((state) => {
                return {
                    mobileMenuIsOpen: false,
                };
            });
        };
        this.toggleMenu = (e) => {
            e.preventDefault();
            this.setState((state) => {
                return {
                    mobileMenuIsOpen: !state.mobileMenuIsOpen,
                };
            });
        };
        this.state = {
            mobileMenuIsOpen: false,
        };
    }
    componentDidMount() {
        this.props.context.getStore(ApplicationStore_1.default).addChangeListener(this.closeMenu);
        if (window.location.href.indexOf('wow') === -1) {
            (0, clientDebug_1.initLoggingOnLoad)();
        }
    }
    componentWillUnmount() {
        this.props.context.getStore(ApplicationStore_1.default).removeChangeListener(this.closeMenu);
    }
    render() {
        const Handler = this.props.context.getStore(fluxible_router_1.RouteStore).getCurrentNavigate().route.handler;
        // tslint:disable-next-line:max-line-length
        const title = format(this.props.context.getStore(fluxible_router_1.RouteStore).getCurrentNavigate().route.title, [this.props.siteTitle]);
        return (React.createElement(React.Fragment, null,
            React.createElement("header", { id: "site_header", className: "header" },
                React.createElement("div", { className: "my-photo" },
                    React.createElement("img", { src: "/public/images/my_photo_xbim.jpg", alt: "image" }),
                    React.createElement("div", { className: "mask" })),
                React.createElement("div", { className: "site-title-block" },
                    React.createElement("h1", { className: "site-title" }, "Maxim Gerasimov"),
                    React.createElement("h1", { className: "site-title" }, "\"xbim\""),
                    React.createElement("p", { className: "site-description" }, "Full stack developer")),
                React.createElement("a", { onClick: this.toggleMenu, className: "menu-toggle mobile-visible" },
                    React.createElement("i", { className: "fa fa-bars" }))),
            React.createElement("div", { className: "site-main" },
                React.createElement("div", { className: "pt-wrapper" },
                    React.createElement(Nav_1.default, { currentRoute: this.props.currentRoute, isResumeVisible: this.props.resume, links: pages.default, isOpenMenu: this.state.mobileMenuIsOpen }),
                    React.createElement(react_helmet_1.Helmet, null,
                        React.createElement("title", null, title),
                        this.props.imageUrl ? React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }) :
                            React.createElement("meta", { name: "twitter:card", content: "summary" }),
                        this.props.imageUrl && React.createElement("meta", { name: "og:image", content: this.props.imageUrl }),
                        React.createElement("meta", { property: "og:url", content: this.props.host + this.props.path }),
                        React.createElement("meta", { property: "og:title", content: title }),
                        React.createElement("meta", { property: "og:site_name", content: this.props.siteTitle }),
                        React.createElement("meta", { property: "og:description", content: this.props.description }),
                        React.createElement("meta", { property: "description", content: this.props.description }),
                        this.props.twitterName && React.createElement("meta", { name: "twitter:site", content: this.props.twitterName }),
                        this.props.twitterName && React.createElement("meta", { name: "twitter:creator", content: this.props.twitterName })),
                    React.createElement(Handler, null)))));
    }
}
exports.default = (0, fluxible_addons_react_1.provideContext)((0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(Application, [ApplicationStore_1.default], (context, props) => {
    var _a;
    return {
        siteTitle: (context.getStore(ApplicationStore_1.default).getParam('site_title')) || 'xbim.dev',
        description: context.getStore(ApplicationStore_1.default).getParam('site_description') || '',
        resume: (context.getStore(ApplicationStore_1.default).getParam('resume')) === 'true',
        imageUrl: context.getStore(ApplicationStore_1.default).getParam('about_picUrl'),
        host: context.getStore(ApplicationStore_1.default).getParam('host'),
        path: context.getStore(ApplicationStore_1.default).getPath(),
        twitterName: (_a = context.getStore(ApplicationStore_1.default).getParam('twitter_name')) !== null && _a !== void 0 ? _a : 'Xbim_dev',
    };
})));
function format(text, args) {
    if (!text) {
        return '';
    }
    return text.replace(/{(\d+)}/g, (match, num) => {
        return typeof args[num] !== 'undefined'
            ? args[num]
            : match;
    });
}
